// 구매 관리 목업 데이터 - 농산물 박스 공장

import type {
  Supplier,
  SupplierGroup,
  PurchaseOrder,
  PurchaseReceipt,
  PurchaseInvoice,
  MaterialRequest,
} from '../types';

// 공급업체 그룹 - 농산물 박스 원자재
export const supplierGroups: SupplierGroup[] = [
  { id: 'SG001', name: '원지 공급', description: '라이너/골심지 원지 공급업체', supplierCount: 4 },
  { id: 'SG002', name: '골판지 제조', description: '골판지 원단 제조 공급업체', supplierCount: 2 },
  { id: 'SG003', name: '부자재', description: '잉크/풀/테이프 등 부자재 공급업체', supplierCount: 3 },
  { id: 'SG004', name: '설비/장비', description: '제함기/인쇄기 등 설비 공급업체', supplierCount: 1 },
];

// 공급업체 - 원지/골판지/부자재
export const suppliers: Supplier[] = [
  {
    id: 'SUP001',
    code: 'SUP-001',
    name: '(주)한국제지',
    supplierGroup: 'SG001',
    contactPerson: '김원지',
    email: 'kim@hankookpaper.co.kr',
    phone: '02-1234-5678',
    address: '서울시 영등포구 여의대로 123',
    taxId: '123-45-67890',
    bankAccount: '123-456-789012',
    bankName: '국민은행',
    paymentTerms: '익월말 결제',
    currency: 'KRW',
    isActive: true,
    totalPurchase: 450000000,
    outstandingAmount: 58000000,
    createdAt: '2024-01-15',
    updatedAt: '2025-01-20',
  },
  {
    id: 'SUP002',
    code: 'SUP-002',
    name: '신호제지(주)',
    supplierGroup: 'SG001',
    contactPerson: '이제지',
    email: 'lee@shinhopaper.com',
    phone: '055-2345-6789',
    address: '경남 진주시 문산읍 제지로 456',
    taxId: '234-56-78901',
    bankAccount: '234-567-890123',
    bankName: '신한은행',
    paymentTerms: '30일 결제',
    currency: 'KRW',
    isActive: true,
    totalPurchase: 320000000,
    outstandingAmount: 42000000,
    createdAt: '2024-02-10',
    updatedAt: '2025-01-15',
  },
  {
    id: 'SUP003',
    code: 'SUP-003',
    name: '태영제지',
    supplierGroup: 'SG001',
    contactPerson: '박태영',
    email: 'park@taeyoungpaper.co.kr',
    phone: '054-3456-7890',
    address: '경북 안동시 풍천면 제지단지로 789',
    taxId: '345-67-89012',
    bankAccount: '345-678-901234',
    bankName: '우리은행',
    paymentTerms: '30일 결제',
    currency: 'KRW',
    isActive: true,
    totalPurchase: 185000000,
    outstandingAmount: 25000000,
    createdAt: '2024-03-05',
    updatedAt: '2025-01-18',
  },
  {
    id: 'SUP004',
    code: 'SUP-004',
    name: '중앙골판지',
    supplierGroup: 'SG002',
    contactPerson: '최골판',
    email: 'choi@jungangcb.com',
    phone: '031-4567-8901',
    address: '경기도 안성시 공도읍 골판지로 321',
    taxId: '456-78-90123',
    bankAccount: '456-789-012345',
    bankName: '하나은행',
    paymentTerms: '익월말 결제',
    currency: 'KRW',
    isActive: true,
    totalPurchase: 280000000,
    outstandingAmount: 38000000,
    createdAt: '2024-04-20',
    updatedAt: '2025-01-10',
  },
  {
    id: 'SUP005',
    code: 'SUP-005',
    name: '삼진화학',
    supplierGroup: 'SG003',
    contactPerson: '정화학',
    email: 'jung@samjinchem.com',
    phone: '032-5678-9012',
    address: '인천시 남동구 화학단지로 567',
    taxId: '567-89-01234',
    bankAccount: '567-890-123456',
    bankName: 'IBK기업은행',
    paymentTerms: '현금결제',
    currency: 'KRW',
    isActive: true,
    totalPurchase: 85000000,
    outstandingAmount: 12000000,
    createdAt: '2024-05-15',
    updatedAt: '2025-01-22',
  },
  {
    id: 'SUP006',
    code: 'SUP-006',
    name: '동아잉크',
    supplierGroup: 'SG003',
    contactPerson: '강잉크',
    email: 'kang@dongaink.co.kr',
    phone: '02-6789-0123',
    address: '서울시 금천구 가산디지털로 234',
    taxId: '678-90-12345',
    bankAccount: '678-901-234567',
    bankName: '농협은행',
    paymentTerms: '익월 15일 결제',
    currency: 'KRW',
    isActive: true,
    totalPurchase: 65000000,
    outstandingAmount: 8500000,
    createdAt: '2024-06-10',
    updatedAt: '2024-12-01',
  },
  {
    id: 'SUP007',
    code: 'SUP-007',
    name: '한일테이프',
    supplierGroup: 'SG003',
    contactPerson: '윤테이프',
    email: 'yoon@haniltape.kr',
    phone: '02-7890-1234',
    address: '서울시 송파구 테이프로 456',
    taxId: '789-01-23456',
    bankAccount: '789-012-345678',
    bankName: '신한은행',
    paymentTerms: '현금결제',
    currency: 'KRW',
    isActive: true,
    totalPurchase: 28000000,
    outstandingAmount: 4200000,
    createdAt: '2024-07-25',
    updatedAt: '2025-01-05',
  },
  {
    id: 'SUP008',
    code: 'SUP-008',
    name: '(주)골판지기계',
    supplierGroup: 'SG004',
    contactPerson: '한기계',
    email: 'han@cbmachine.co.kr',
    phone: '054-8901-2345',
    address: '경북 구미시 산업단지로 890',
    taxId: '890-12-34567',
    bankAccount: '890-123-456789',
    bankName: '국민은행',
    paymentTerms: '선금 50%, 설치 후 50%',
    currency: 'KRW',
    isActive: true,
    totalPurchase: 520000000,
    outstandingAmount: 75000000,
    createdAt: '2024-08-15',
    updatedAt: '2025-01-12',
  },
];

// 발주서 - 원지/골판지/부자재
export const purchaseOrders: PurchaseOrder[] = [
  {
    id: 'PO001',
    code: 'PO-2025-001',
    supplierId: 'SUP001',
    supplierName: '(주)한국제지',
    status: 'completed',
    orderDate: '2025-01-05',
    requiredDate: '2025-01-15',
    items: [
      {
        id: 'POI001',
        itemCode: 'LN-K180',
        itemName: 'K라이너 180g',
        quantity: 10000,
        receivedQty: 10000,
        uom: 'kg',
        unitPrice: 520,
        amount: 5200000,
        warehouse: 'WH002',
      },
      {
        id: 'POI002',
        itemCode: 'LN-K200',
        itemName: 'K라이너 200g',
        quantity: 8000,
        receivedQty: 8000,
        uom: 'kg',
        unitPrice: 580,
        amount: 4640000,
        warehouse: 'WH002',
      },
    ],
    totalQty: 18000,
    totalAmount: 9840000,
    taxAmount: 984000,
    grandTotal: 10824000,
    receivedQty: 18000,
    billedAmount: 10824000,
    remarks: '1월 정기 발주',
    createdAt: '2025-01-05',
    updatedAt: '2025-01-16',
  },
  {
    id: 'PO002',
    code: 'PO-2025-002',
    supplierId: 'SUP003',
    supplierName: '태영제지',
    status: 'to_receive',
    orderDate: '2025-01-18',
    requiredDate: '2025-01-28',
    items: [
      {
        id: 'POI003',
        itemCode: 'CM-127',
        itemName: '골심지 127g',
        quantity: 15000,
        receivedQty: 0,
        uom: 'kg',
        unitPrice: 380,
        amount: 5700000,
        warehouse: 'WH002',
      },
    ],
    totalQty: 15000,
    totalAmount: 5700000,
    taxAmount: 570000,
    grandTotal: 6270000,
    receivedQty: 0,
    billedAmount: 0,
    createdAt: '2025-01-18',
    updatedAt: '2025-01-18',
  },
  {
    id: 'PO003',
    code: 'PO-2025-003',
    supplierId: 'SUP004',
    supplierName: '중앙골판지',
    status: 'to_bill',
    orderDate: '2025-01-10',
    requiredDate: '2025-01-20',
    items: [
      {
        id: 'POI004',
        itemCode: 'CB-E120',
        itemName: 'E골 골판지 120cm',
        quantity: 3000,
        receivedQty: 3000,
        uom: 'm²',
        unitPrice: 650,
        amount: 1950000,
        warehouse: 'WH002',
      },
      {
        id: 'POI005',
        itemCode: 'CB-B120',
        itemName: 'B골 골판지 120cm',
        quantity: 2500,
        receivedQty: 2500,
        uom: 'm²',
        unitPrice: 700,
        amount: 1750000,
        warehouse: 'WH002',
      },
      {
        id: 'POI006',
        itemCode: 'CB-BC120',
        itemName: 'BC골 골판지 120cm',
        quantity: 1500,
        receivedQty: 1500,
        uom: 'm²',
        unitPrice: 850,
        amount: 1275000,
        warehouse: 'WH002',
      },
    ],
    totalQty: 7000,
    totalAmount: 4975000,
    taxAmount: 497500,
    grandTotal: 5472500,
    receivedQty: 7000,
    billedAmount: 0,
    createdAt: '2025-01-10',
    updatedAt: '2025-01-21',
  },
  {
    id: 'PO004',
    code: 'PO-2025-004',
    supplierId: 'SUP005',
    supplierName: '삼진화학',
    status: 'submitted',
    orderDate: '2025-01-25',
    requiredDate: '2025-02-05',
    items: [
      {
        id: 'POI007',
        itemCode: 'SUP-GLUE',
        itemName: '전분 풀',
        quantity: 2000,
        receivedQty: 0,
        uom: 'kg',
        unitPrice: 1200,
        amount: 2400000,
        warehouse: 'WH001',
      },
    ],
    totalQty: 2000,
    totalAmount: 2400000,
    taxAmount: 240000,
    grandTotal: 2640000,
    receivedQty: 0,
    billedAmount: 0,
    remarks: '생산용 접착제',
    createdAt: '2025-01-25',
    updatedAt: '2025-01-25',
  },
  {
    id: 'PO005',
    code: 'PO-2025-005',
    supplierId: 'SUP006',
    supplierName: '동아잉크',
    status: 'draft',
    orderDate: '2025-01-27',
    requiredDate: '2025-02-10',
    items: [
      {
        id: 'POI008',
        itemCode: 'SUP-INK',
        itemName: '인쇄 잉크',
        quantity: 100,
        receivedQty: 0,
        uom: 'kg',
        unitPrice: 11000,
        amount: 1100000,
        warehouse: 'WH001',
      },
    ],
    totalQty: 100,
    totalAmount: 1100000,
    taxAmount: 110000,
    grandTotal: 1210000,
    receivedQty: 0,
    billedAmount: 0,
    remarks: '플렉소 인쇄기용',
    createdAt: '2025-01-27',
    updatedAt: '2025-01-27',
  },
];

// 입고
export const purchaseReceipts: PurchaseReceipt[] = [
  {
    id: 'PR001',
    code: 'PR-2025-001',
    supplierId: 'SUP001',
    supplierName: '(주)한국제지',
    purchaseOrderId: 'PO001',
    purchaseOrderCode: 'PO-2025-001',
    status: 'completed',
    receiptDate: '2025-01-14',
    items: [
      {
        id: 'PRI001',
        itemCode: 'LN-K180',
        itemName: 'K라이너 180g',
        quantity: 10000,
        uom: 'kg',
        unitPrice: 520,
        amount: 5200000,
        warehouse: 'WH002',
        purchaseOrderId: 'PO001',
      },
      {
        id: 'PRI002',
        itemCode: 'LN-K200',
        itemName: 'K라이너 200g',
        quantity: 8000,
        uom: 'kg',
        unitPrice: 580,
        amount: 4640000,
        warehouse: 'WH002',
        purchaseOrderId: 'PO001',
      },
    ],
    totalQty: 18000,
    totalAmount: 9840000,
    warehouse: 'WH002',
    remarks: '품질 검사 합격',
    createdAt: '2025-01-14',
    updatedAt: '2025-01-14',
  },
  {
    id: 'PR002',
    code: 'PR-2025-002',
    supplierId: 'SUP004',
    supplierName: '중앙골판지',
    purchaseOrderId: 'PO003',
    purchaseOrderCode: 'PO-2025-003',
    status: 'completed',
    receiptDate: '2025-01-19',
    items: [
      {
        id: 'PRI003',
        itemCode: 'CB-E120',
        itemName: 'E골 골판지 120cm',
        quantity: 3000,
        uom: 'm²',
        unitPrice: 650,
        amount: 1950000,
        warehouse: 'WH002',
        purchaseOrderId: 'PO003',
      },
      {
        id: 'PRI004',
        itemCode: 'CB-B120',
        itemName: 'B골 골판지 120cm',
        quantity: 2500,
        uom: 'm²',
        unitPrice: 700,
        amount: 1750000,
        warehouse: 'WH002',
        purchaseOrderId: 'PO003',
      },
      {
        id: 'PRI005',
        itemCode: 'CB-BC120',
        itemName: 'BC골 골판지 120cm',
        quantity: 1500,
        uom: 'm²',
        unitPrice: 850,
        amount: 1275000,
        warehouse: 'WH002',
        purchaseOrderId: 'PO003',
      },
    ],
    totalQty: 7000,
    totalAmount: 4975000,
    warehouse: 'WH002',
    createdAt: '2025-01-19',
    updatedAt: '2025-01-19',
  },
  {
    id: 'PR003',
    code: 'PR-2025-003',
    supplierId: 'SUP007',
    supplierName: '한일테이프',
    status: 'submitted',
    receiptDate: '2025-01-22',
    items: [
      {
        id: 'PRI006',
        itemCode: 'SUP-TAPE',
        itemName: '포장테이프',
        quantity: 200,
        uom: '롤',
        unitPrice: 2200,
        amount: 440000,
        warehouse: 'WH001',
      },
    ],
    totalQty: 200,
    totalAmount: 440000,
    warehouse: 'WH001',
    remarks: '긴급 입고',
    createdAt: '2025-01-22',
    updatedAt: '2025-01-22',
  },
];

// 구매 청구서
export const purchaseInvoices: PurchaseInvoice[] = [
  {
    id: 'PINV001',
    code: 'PINV-2025-001',
    supplierId: 'SUP001',
    supplierName: '(주)한국제지',
    purchaseOrderId: 'PO001',
    purchaseOrderCode: 'PO-2025-001',
    status: 'paid',
    invoiceDate: '2025-01-15',
    dueDate: '2025-02-28',
    items: [
      {
        id: 'PINVI001',
        itemCode: 'LN-K180',
        itemName: 'K라이너 180g',
        quantity: 10000,
        uom: 'kg',
        unitPrice: 520,
        amount: 5200000,
        purchaseOrderId: 'PO001',
        purchaseReceiptId: 'PR001',
      },
      {
        id: 'PINVI002',
        itemCode: 'LN-K200',
        itemName: 'K라이너 200g',
        quantity: 8000,
        uom: 'kg',
        unitPrice: 580,
        amount: 4640000,
        purchaseOrderId: 'PO001',
        purchaseReceiptId: 'PR001',
      },
    ],
    totalAmount: 9840000,
    taxAmount: 984000,
    grandTotal: 10824000,
    paidAmount: 10824000,
    outstandingAmount: 0,
    createdAt: '2025-01-15',
    updatedAt: '2025-01-20',
  },
  {
    id: 'PINV002',
    code: 'PINV-2025-002',
    supplierId: 'SUP002',
    supplierName: '신호제지(주)',
    status: 'unpaid',
    invoiceDate: '2025-01-20',
    dueDate: '2025-02-20',
    items: [
      {
        id: 'PINVI003',
        itemCode: 'CM-127',
        itemName: '골심지 127g',
        quantity: 12000,
        uom: 'kg',
        unitPrice: 380,
        amount: 4560000,
      },
    ],
    totalAmount: 4560000,
    taxAmount: 456000,
    grandTotal: 5016000,
    paidAmount: 0,
    outstandingAmount: 5016000,
    createdAt: '2025-01-20',
    updatedAt: '2025-01-20',
  },
  {
    id: 'PINV003',
    code: 'PINV-2025-003',
    supplierId: 'SUP008',
    supplierName: '(주)골판지기계',
    status: 'partial',
    invoiceDate: '2025-01-10',
    dueDate: '2025-01-25',
    items: [
      {
        id: 'PINVI004',
        itemCode: 'EQP-001',
        itemName: '제함기 오버홀',
        quantity: 1,
        uom: '건',
        unitPrice: 25000000,
        amount: 25000000,
      },
    ],
    totalAmount: 25000000,
    taxAmount: 2500000,
    grandTotal: 27500000,
    paidAmount: 13750000,
    outstandingAmount: 13750000,
    remarks: '선금 50% 지급완료',
    createdAt: '2025-01-10',
    updatedAt: '2025-01-12',
  },
  {
    id: 'PINV004',
    code: 'PINV-2025-004',
    supplierId: 'SUP005',
    supplierName: '삼진화학',
    status: 'overdue',
    invoiceDate: '2024-12-15',
    dueDate: '2025-01-15',
    items: [
      {
        id: 'PINVI005',
        itemCode: 'SUP-GLUE',
        itemName: '전분 풀',
        quantity: 1500,
        uom: 'kg',
        unitPrice: 1200,
        amount: 1800000,
      },
    ],
    totalAmount: 1800000,
    taxAmount: 180000,
    grandTotal: 1980000,
    paidAmount: 0,
    outstandingAmount: 1980000,
    remarks: '결제 지연 - 담당자 확인 필요',
    createdAt: '2024-12-15',
    updatedAt: '2025-01-16',
  },
];

// 자재 요청
export const materialRequests: MaterialRequest[] = [
  {
    id: 'MR001',
    code: 'MR-2025-001',
    type: 'purchase',
    status: 'ordered',
    requestDate: '2025-01-03',
    requiredDate: '2025-01-15',
    requestedBy: '김생산',
    department: '생산부',
    items: [
      {
        id: 'MRI001',
        itemCode: 'LN-K180',
        itemName: 'K라이너 180g',
        quantity: 10000,
        orderedQty: 10000,
        receivedQty: 10000,
        uom: 'kg',
        warehouse: 'WH002',
      },
    ],
    totalQty: 10000,
    remarks: '1월 생산용 원지',
    createdAt: '2025-01-03',
    updatedAt: '2025-01-15',
  },
  {
    id: 'MR002',
    code: 'MR-2025-002',
    type: 'purchase',
    status: 'pending',
    requestDate: '2025-01-25',
    requiredDate: '2025-02-10',
    requestedBy: '이구매',
    department: '구매부',
    items: [
      {
        id: 'MRI002',
        itemCode: 'CB-BC180',
        itemName: 'BC골 골판지 180cm',
        quantity: 2000,
        orderedQty: 0,
        receivedQty: 0,
        uom: 'm²',
        warehouse: 'WH002',
      },
      {
        id: 'MRI003',
        itemCode: 'SUP-INK',
        itemName: '인쇄 잉크',
        quantity: 50,
        orderedQty: 0,
        receivedQty: 0,
        uom: 'kg',
        warehouse: 'WH001',
      },
    ],
    totalQty: 2050,
    remarks: '감귤박스 대량 생산용',
    createdAt: '2025-01-25',
    updatedAt: '2025-01-25',
  },
  {
    id: 'MR003',
    code: 'MR-2025-003',
    type: 'material_transfer',
    status: 'submitted',
    requestDate: '2025-01-26',
    requiredDate: '2025-01-27',
    requestedBy: '박창고',
    department: '물류부',
    items: [
      {
        id: 'MRI004',
        itemCode: 'CB-E120',
        itemName: 'E골 골판지 120cm',
        quantity: 500,
        orderedQty: 0,
        receivedQty: 0,
        uom: 'm²',
        warehouse: 'WH002',
      },
    ],
    totalQty: 500,
    remarks: '원자재 창고 → 공장 이동',
    createdAt: '2025-01-26',
    updatedAt: '2025-01-26',
  },
  {
    id: 'MR004',
    code: 'MR-2025-004',
    type: 'manufacture',
    status: 'partially_ordered',
    requestDate: '2025-01-20',
    requiredDate: '2025-02-01',
    requestedBy: '최제조',
    department: '제조부',
    items: [
      {
        id: 'MRI005',
        itemCode: 'LN-K200',
        itemName: 'K라이너 200g',
        quantity: 15000,
        orderedQty: 8000,
        receivedQty: 0,
        uom: 'kg',
        warehouse: 'WH002',
      },
      {
        id: 'MRI006',
        itemCode: 'SUP-GLUE',
        itemName: '전분 풀',
        quantity: 800,
        orderedQty: 0,
        receivedQty: 0,
        uom: 'kg',
        warehouse: 'WH001',
      },
    ],
    totalQty: 15800,
    remarks: '배박스 대량 생산용',
    createdAt: '2025-01-20',
    updatedAt: '2025-01-25',
  },
];

// 헬퍼 함수들
export const getSupplierById = (id: string): Supplier | undefined => {
  return suppliers.find((s) => s.id === id);
};

export const getSupplierGroupById = (id: string): SupplierGroup | undefined => {
  return supplierGroups.find((g) => g.id === id);
};

export const getPurchaseOrderById = (id: string): PurchaseOrder | undefined => {
  return purchaseOrders.find((po) => po.id === id);
};

export const getPurchaseReceiptById = (id: string): PurchaseReceipt | undefined => {
  return purchaseReceipts.find((pr) => pr.id === id);
};

export const getPurchaseInvoiceById = (id: string): PurchaseInvoice | undefined => {
  return purchaseInvoices.find((pi) => pi.id === id);
};

export const getMaterialRequestById = (id: string): MaterialRequest | undefined => {
  return materialRequests.find((mr) => mr.id === id);
};

// 통계 헬퍼
export const getBuyingStats = () => {
  const totalPurchaseOrders = purchaseOrders.length;
  const pendingOrders = purchaseOrders.filter(
    (po) => po.status === 'submitted' || po.status === 'to_receive'
  ).length;
  const totalPurchaseAmount = purchaseOrders
    .filter((po) => po.status !== 'cancelled' && po.status !== 'draft')
    .reduce((sum, po) => sum + po.grandTotal, 0);
  const totalOutstanding = purchaseInvoices.reduce((sum, pi) => sum + pi.outstandingAmount, 0);
  const overdueInvoices = purchaseInvoices.filter((pi) => pi.status === 'overdue').length;
  const activeSuppliers = suppliers.filter((s) => s.isActive).length;

  return {
    totalPurchaseOrders,
    pendingOrders,
    totalPurchaseAmount,
    totalOutstanding,
    overdueInvoices,
    activeSuppliers,
    totalSuppliers: suppliers.length,
  };
};
